export default __webpack_public_path__ + "static/media/procument.92f9695c.jpg";